import { CONSTANTS } from '@sohohouse/platform-resources'

export default venues => {
  const regions = venues.reduce((acc, venue) => {
    let group
    if (venue.venueType === CONSTANTS.VENUE_TYPES.CWH) {
      group = venue.venueType
    } else {
      group = venue.region
    }
    const thisGroup = acc.find(obj => obj.region === group)

    if (thisGroup) {
      thisGroup.venues.push(venue)
    } else {
      acc.push({
        region: group,
        venues: [venue]
      })
    }
    return acc
  }, [])

  regions.map(region => {
    region.venues = region.venues.sort((a, b) => a.name.localeCompare(b.name))
    return region
  })

  regions.sort((a, b) => {
    if (a.region === CONSTANTS.VENUE_TYPES.CWH) {
      return 1
    }

    if (b.region === CONSTANTS.VENUE_TYPES.CWH) {
      return -1
    }

    return a.region.localeCompare(b.region)
  })

  const regionIndex = regions.findIndex(r => r.region === 'WORLDWIDE')

  if (regionIndex >= 0) {
    const region = regions.splice(regionIndex, 1)[0]
    regions.splice(1, 0, region)
  }

  return regions
}
